import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-identifier-pools-product-modal',
  templateUrl: 'identifier-pools-product-modal.component.html',
  styleUrls: ['identifier-pools-product-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IdentifierPoolsProductModalComponent {
  protected readonly ngbActiveModal = inject(NgbActiveModal);
  protected readonly form = new UntypedFormGroup({
    productId: new FormControl('', Validators.required)
  });

  protected close(result?: { productId: string }): void {
    this.ngbActiveModal.close(result?.productId);
  }

  public confirm(): void {
    this.close(this.form.value);
  }
}
